type AiAssistantOpenOptions = {
    domain?: 'chart' | 'screener'
    seedPrompt?: string
    forceNew?: boolean
}

type OpenAssistantFn = (options?: AiAssistantOpenOptions) => void

let openAssistantImpl: OpenAssistantFn | null = null

export function registerAiAssistantOpen(fn: OpenAssistantFn | null): void {
    openAssistantImpl = fn
}

export function openAiAssistant(options?: AiAssistantOpenOptions): void {
    openAssistantImpl?.(options)
}
